import './intro.scss'
import {init} from 'ityped'
import {useEffect,useRef } from 'react';

  

function Intro() {

    const textRef= useRef();

useEffect(() =>{
    // important part
init(textRef.current, {
    showCursor: true,
    backDelay:  1500,
    backSpeed:  50,
    typeSpeed:  80,
    strings: ["A MERN Stack Developer", "An Android Developer", "A Digital Marketer","A Data Scientist"]
})
},[]
)


    return (
        <div className="intro" id="intro">
         <div className="left">
         <div className="imageContainer">
                 <img src="assets/Profile.png"alt=""/>
             </div>
         </div> 
         <div className="right">
             
             <div className="wrapper">
                 <h2>Hi there, I'm</h2>
                 <h1>Hirak Deb Nath</h1>
                 <h3><span ref={textRef}></span></h3>
                
             <a href="#portfolio">
                 <img src="assets/down.png"alt=""/>
             </a>
             </div>
         </div>  
         

        </div>
    )
}

export default Intro
